<script>

    import { toast } from 'bulma-toast'
    import { pricingsStore, modalStore, notifyStore, adminStore } from '../stores'

    import PricingsService from '../$services/pricings.service.js'
    import TranslateMethods from '../$methods/translate.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import Input from '../$components/input.text.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte' 
    import Table from '../$components/table.svelte'

    let query = {
        provider: null,
        service: null,
        volumetricMax: null,
        adminId: $adminStore._id
    }

    let loading = false
    let element = null

    getPricings()

    async function getPricings() {

        loading = true
        const resp = await PricingsService.getPricings(query)
        loading = false
        
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        pricingsStore.set(resp.data)
    }

    $: if ($notifyStore === 'pricings_updated') {
        getPricings()
        notifyStore.set(null)
    }

    function downloadFile() {

        let metadata = 'schema, proveedor, servicio, peso_minimo, peso_maximo, costo_envio, precio_envio\n'

        $pricingsStore.forEach(pricing => {
            metadata += `${pricing.provider}, ${pricing.service}, ${pricing.volumetricMin}, ${pricing.volumetricMax}, ${pricing.shipmentCost}, ${pricing.shipmentPrice}\n`
        })

        const blob = new Blob([metadata], {type: 'text/plain'})

        element.download = `pricing.csv`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} href="/" style="display: none;">.</a>

<Table items={ $pricingsStore.length } { loading }>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column">
                <Input bind:value={ query.provider } on:enter={ getPricings } placeholder="Proveedor" />
            </div>
            <div class="column">
                <Input bind:value={ query.service } on:enter={ getPricings } placeholder="Servicio" />
            </div>
            <div class="column">
                <Input bind:value={ query.volumetricMax } on:enter={ getPricings } placeholder="Volumétrico máximo" />
            </div>

            {#if $adminStore.role === 'admin'}
                <div class="column is-narrow">
                    <div>
                        <Button on:click={() => downloadFile()} icon="file" text="Descargar" />
                        <ButtonModal modalId="pricing_upload_modal" icon="file-upload" text="Subir" />
                        <ButtonModal modalId="pricing_create_modal" icon="plus" text="Crear" />
                    </div>
                </div>
            {/if}
        </div>
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Estatus</th>
            <th>Proveedor</th>
            <th>Servicio</th>
            <th>Peso</th>
            <th class="has-text-right">Precio envío</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $pricingsStore as pricing, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ TranslateMethods.get(pricing.status) }</td>
                <td>{ pricing.provider }</td>
                <td>{ pricing.service }</td>
                <td>{ pricing.volumetricMin }kg a { pricing.volumetricMax }Kg</td>
                <td class="has-text-right">{ NumeralMethods.cash(pricing.shipmentPrice) }</td>
                <td class="has-text-right">
                    <Button on:click={() => modalStore.open('pricing', 'modal', pricing)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>